import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import styled from "styled-components";

const RepresentativesContainerWrapper = styled.a`
  background: #ffffff;
  border-radius: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  height: 100px;
  text-decoration: none;
  color: initial;
  padding-right: 1rem;
  padding-left: 1rem;

  &:hover {
    background: ${({ theme }) => theme.colors.blue};

    h5 {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

const RepresentativeLabel = styled.h5`
  margin: 0;
  text-align: center;
`;

const RepresentativesContainer = (props) => {
  const navigate = useNavigate();

  return (
    <RepresentativesContainerWrapper
      href="!#"
      onClick={(e) => {
        e.preventDefault();
        navigate(props.link);
      }}
    >
      <RepresentativeLabel>{props?.label}</RepresentativeLabel>
    </RepresentativesContainerWrapper>
  );
};

RepresentativesContainer.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default RepresentativesContainer;
